class LazyAsset extends window.WIP.CustomElement() {
  static get requiredElements() {
    return ["template"];
  }

  static get requiredAttributes() {
    return ["data-name", "data-type"];
  }

  connectedCallback() {
    super.connectedCallback();
    this.register();
  }

  register() {
    if (this.domEvent) this.registerDomEvents();
    if (this.domSelector) this.registerDomSelectorEvent();
    if (this.type) this.registerTypeLoader();
  }

  registerTypeLoader() {
    switch (this.type) {
      case "nearby":
        this.waitTilMouseIsNear();
        break;
      case "interaction":
        window.innerWidth < 768
          ? window.WIP.Utils.docReady(() => this.handleLoad())
          : window.WIP.Utils.onUserDocumentInteraction(() => this.handleLoad());
        break;
      case "ready":
        window.WIP.Utils.docReady(() => this.handleLoad());
        break;
      case "intersection":
        this.initIntersectionObserver();
        break;
      case "idle":
        window.WIP.Utils.onWindowIdle(() => this.handleLoad());
        break;
      case "window":
        window.WIP.Utils.onWindowLoad(() => this.handleLoad());
        break;
      case "mobile":
        this.mobileMount();
        break;
    }
  }

  initIntersectionObserver() {
    if (!this.domEl) return;

    if (!this.observer) {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            observer.unobserve(this.domEl);
            this.handleLoad();
          }
        },
        { threshold: 0.1 }
      );
    }

    this.observer.observe(this.domEl);
  }

  mobileMount() {
    if (matchMedia("(max-width: 768px)").matches) {
      window.WIP.Utils.onWindowLoad(() => this.handleLoad());
    } else {
      const resizeHandler = window.WIP.Utils.debounce(() => {
        if (matchMedia("(max-width: 768px)").matches) {
          this.handleLoad();
        }
      }, 250);
      window.addEventListener("resize", resizeHandler, { once: true });
    }
  }

  registerDomSelectorEvent() {
    if (!this.domSelector) return;
    const $el = document.querySelector(this.domSelector);
    if (!$el) return;

    this.listeners.add(
      $el,
      this.event || "mouseenter",
      () => this.handleLoad(),
      { once: true }
    );
  }

  waitTilMouseIsNear($el = this.domEl) {
    if (!$el) return;

    const threshold = 200;
    const { top, left, right, bottom } = $el.getBoundingClientRect();

    const boundaries = {
      top: top - threshold,
      left: left - threshold,
      bottom: bottom + threshold,
      right: right + threshold,
    };

    const handleMouseMove = (event) => {
      const { clientX: mouseX, clientY: mouseY } = event;

      if (
        mouseY > boundaries.top &&
        mouseY < boundaries.bottom &&
        mouseX > boundaries.left &&
        mouseX < boundaries.right
      ) {
        document.removeEventListener("mousemove", handleMouseMove);
        this.handleLoad();
      }
    };

    document.addEventListener("mousemove", handleMouseMove, { once: true });
  }

  registerDomEvents() {
    if (!this.domEvent) return;

    const events =
      this.domEvent === "CART_EVENTS"
        ? [...window.WIP.Events.cartEvents]
        : [this.domEvent];

    events.forEach((event) =>
      this.listeners.add(document, event, () => this.handleLoad(), {
        once: true,
      })
    );

    if (this.domEvent === "CART_EVENTS") {
      document
        .querySelectorAll('form[action="/cart/add"],a[href="/cart"]')
        .forEach(($node) =>
          this.listeners.add($node, "mouseenter", () => this.handleLoad(), {
            once: true,
          })
        );
    }
  }

  handleLoad = () => {
    this.listeners.removeAll();

    const clone = document.importNode(this.template.content, true);
    clone
      .querySelectorAll("script")
      .forEach(($script) => $script.setAttribute("defer", "true"));

    document.body.appendChild(clone);
  };

  get type() {
    return this.dataset.type;
  }

  get domSelector() {
    return this.dataset.domSelector;
  }

  get domEl() {
    return this.domSelector
      ? document.querySelector(this.domSelector)
      : undefined;
  }

  get event() {
    return this.dataset.event;
  }

  get domEvent() {
    return this.dataset.domEvent;
  }

  get name() {
    return this.dataset.name;
  }

  get template() {
    return this.els.template.element;
  }

  get isRegistered() {
    return !!customElements.get("cart-drawer");
  }
}

window.WIP.Components = window.WIP.Components || {};
window.WIP.Components.LazyAsset = LazyAsset;

customElements.define("lazy-asset", LazyAsset);
document.dispatchEvent(new CustomEvent("components-ready"));
